import React, { useState } from "react";
import { Button, Input, Form, Modal, Typography, Tooltip, Select } from "antd";
import Icon from "@ant-design/icons";
import axios from "axios";
import userImage from "./../../assets/Images/dog1.svg";
import botImage from "./../../assets/Images/dog2.svg";

import "./contact.css";

const ChatBot = () => {
  const [form] = Form.useForm();
  const { Option } = Select;

  const [chatData, setChatData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [productDetail, setProductDetail] = useState();
  const [isFloting, setIsFloting] = useState(true);
  const [selectedSample, setSelectedSample] = useState(null);

  const openAiResponse = async (message) => {
    await axios
      .post(
        "https://api.openai.com/v1/completions",
        {
          model: "text-davinci-002",
          prompt: `${message}`,
          temperature: 0.7,
          top_p: 1,
          max_tokens: 256,
          frequency_penalty: 0,
          presence_penalty: 0.6,
          best_of: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
            Organization: "org-wJB2ibmYLTYQe8EM8dtnYQiT",
          },
        }
      )
      .then((res) => {
        setChatData((prev) => {
          return [
            ...prev,
            [
              "chatBot",
              JSON.parse(res.request.responseText).choices[0].text
                ? JSON.parse(res.request.responseText).choices[0].text
                : "Sorry, No Response Available!",
            ],
          ];
        });
        updateScroll();
      });
  };

  const sendMessage = (props) => {
    setChatData((prev) => {
      return [...prev, ["User", props.message]];
    });
    updateScroll();
    form.resetFields();
    const intialvalue = "";
    const previousData = chatData.reduce((previousValue, currentValue) => {
      return previousValue + `${currentValue[1]}\n`;
    }, intialvalue);
    openAiResponse(
      `${productDetail ? productDetail : ""}\n${previousData}${props.message}\n`
    );
  };

  const clearChat = () => {
    setChatData([]);
  };

  const productSvg = () => (
    <svg
      width="33"
      height="26"
      viewBox="0 0 33 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.9012 7.69179C31.8578 7.60488 31.8143 7.47452 31.7709 7.38762L31.0322 5.8233C30.3804 4.47625 29.7286 3.08575 29.1202 1.7387C28.8595 1.21727 28.5119 1 27.947 1C25.9916 1 24.0362 1 22.0808 1H11.2175C9.13176 1 7.08946 1 5.00371 1C4.48227 1 4.13464 1.21727 3.96083 1.6518C3.48285 2.65122 2.96141 3.6941 2.48342 4.69352C2.04889 5.64949 1.57091 6.60546 1.13638 7.56143C0.962562 7.90906 0.962562 8.21323 1.09292 8.47395C1.22328 8.69121 1.52745 8.86503 1.96199 8.86503H2.35306C2.52688 8.86503 2.70069 8.86503 2.8745 8.86503C3.09177 8.86503 3.30903 8.86503 3.56975 8.86503H3.61321C3.74357 8.86503 3.78702 8.86503 3.83047 8.90848C3.87393 8.95193 3.91738 9.03884 3.91738 9.21265C3.91738 11.6026 3.91738 17.0915 3.91738 19.4814V21.0892C3.91738 21.8279 4.09119 22.0452 4.78644 22.219L6.82874 22.697C9.87046 23.4357 12.9122 24.1744 15.9539 24.9131C16.1277 24.9566 16.3015 25 16.4753 25C16.6492 25 16.823 25 16.9968 24.9131C19.5171 24.3048 22.0374 23.6964 24.5576 23.0881L28.0773 22.219C28.8595 22.0452 29.0333 21.8279 29.0333 21.0023V19.2642C29.0333 16.9177 29.0333 11.5157 29.0333 9.1692C29.0333 9.03884 29.0333 8.95193 29.0768 8.90848C29.1202 8.86503 29.1637 8.86503 29.294 8.86503H29.3375C29.5982 8.86503 29.8589 8.86503 30.1196 8.86503C30.4238 8.86503 30.728 8.86503 31.0756 8.86503C31.3798 8.86503 31.6405 8.73467 31.8143 8.5174C32.0316 8.30013 32.0316 7.99596 31.9012 7.69179ZM27.4255 20.3505C27.4255 20.6547 27.3386 20.7416 27.0345 20.8285C23.8624 21.5672 20.7338 22.3494 17.6051 23.1315C17.5182 23.1315 17.4748 23.175 17.4313 23.175C17.3879 23.175 17.3879 23.175 17.3444 23.175C17.301 23.1315 17.301 23.0881 17.301 22.9577C17.301 21.8714 17.301 14.3401 17.301 10.8204V7.95251C17.301 7.17035 17.301 6.3882 17.3444 5.60604L18.1266 7.21381L18.2569 7.51798C18.3873 7.7787 18.5176 7.99596 18.6046 8.25668C18.7784 8.69121 19.0825 8.86503 19.604 8.86503C20.8207 8.86503 22.0374 8.86503 23.254 8.86503H27.0345C27.4255 8.86503 27.4255 8.86503 27.4255 9.25611V11.2984C27.3821 13.2538 27.3821 18.3517 27.4255 20.3505ZM22.5588 7.21381C21.7766 7.21381 21.0379 7.21381 20.2558 7.21381C20.0385 7.21381 19.9081 7.1269 19.8212 6.95309C19.3867 5.99712 18.9522 5.04115 18.4742 4.12863L17.9093 2.91194C17.8658 2.82503 17.8224 2.73813 17.8224 2.69467C17.8658 2.69467 17.9962 2.69467 18.0831 2.69467H21.2117C23.2975 2.69467 25.3832 2.69467 27.469 2.69467C27.6863 2.69467 27.7732 2.78158 27.8601 2.95539C28.5119 4.3459 29.1637 5.69294 29.8155 7.08345C29.8589 7.21381 29.8589 7.25726 29.8589 7.25726C29.8589 7.25726 29.8155 7.30071 29.6851 7.30071C28.903 7.30071 28.1643 7.30071 27.3821 7.30071L22.5588 7.21381ZM5.5686 2.60777V2.69467C7.65435 2.69467 9.7401 2.69467 11.8259 2.69467H14.9545C15.0414 2.69467 15.1718 2.69467 15.1718 2.69467C15.1718 2.73813 15.1283 2.86849 15.0848 2.91194L14.4765 4.12863C14.042 5.0846 13.564 6.04057 13.1295 6.99654C13.0425 7.17035 12.9556 7.21381 12.7384 7.21381C11.9128 7.21381 11.0872 7.21381 10.2615 7.21381H5.5686C4.8299 7.21381 4.09119 7.21381 3.30903 7.21381C3.17867 7.25726 3.17867 7.21381 3.17867 7.21381C3.17867 7.21381 3.17867 7.17035 3.22213 7.03999C3.78702 5.8233 4.43882 4.47625 5.13407 2.95539C5.22097 2.73813 5.35133 2.65122 5.5686 2.65122V2.60777ZM5.95968 8.77812V8.86503C7.08946 8.86503 8.21924 8.86503 9.30557 8.86503H9.91392C11.0437 8.86503 12.1735 8.86503 13.3467 8.86503C13.8682 8.86503 14.1723 8.64776 14.3896 8.21323C14.6938 7.51798 15.0414 6.82273 15.389 6.12748L15.6932 5.51913V6.77927C15.6932 8.12632 15.6932 17.8737 15.6932 21.1761V22.8273C15.6932 23.175 15.6932 23.2184 15.6497 23.2184C15.6063 23.2184 15.4759 23.175 15.3456 23.175L13.3902 22.697C10.9568 22.0886 8.47996 21.5237 6.04658 20.9154C5.74241 20.8285 5.65551 20.7416 5.65551 20.4374C5.65551 17.9171 5.65551 12.1675 5.65551 9.29956C5.65551 9.12575 5.65551 9.03884 5.74241 8.99539C5.78586 8.95193 5.87277 8.90848 6.04658 8.90848L5.95968 8.77812Z"
        fill="white"
      />
      <path
        d="M27.469 2.69467C25.3832 2.69467 23.2975 2.69467 21.2117 2.69467H18.0831C17.9962 2.69467 17.8658 2.69467 17.8224 2.69467C17.8224 2.73813 17.8658 2.82503 17.9093 2.91194L18.4742 4.12863C18.9522 5.04115 19.3867 5.99712 19.8212 6.95309C19.9081 7.1269 20.0385 7.21381 20.2558 7.21381C21.0379 7.21381 21.7766 7.21381 22.5588 7.21381L27.3821 7.30071C28.1643 7.30071 28.903 7.30071 29.6851 7.30071C29.8155 7.30071 29.8589 7.25726 29.8589 7.25726C29.8589 7.25726 29.8589 7.21381 29.8155 7.08345C29.1637 5.69294 28.5119 4.3459 27.8601 2.95539C27.7732 2.78158 27.6863 2.69467 27.469 2.69467ZM27.469 2.69467V2.60777M31.9012 7.69179C31.8578 7.60488 31.8143 7.47452 31.7709 7.38762L31.0322 5.8233C30.3804 4.47625 29.7286 3.08575 29.1202 1.7387C28.8595 1.21727 28.5119 1 27.947 1C25.9916 1 24.0362 1 22.0808 1H11.2175C9.13176 1 7.08946 1 5.00371 1C4.48227 1 4.13464 1.21727 3.96083 1.6518C3.48285 2.65122 2.96141 3.6941 2.48342 4.69352C2.04889 5.64949 1.57091 6.60546 1.13638 7.56143C0.962562 7.90906 0.962562 8.21323 1.09292 8.47395C1.22328 8.69121 1.52745 8.86503 1.96199 8.86503H2.35306C2.52688 8.86503 2.70069 8.86503 2.8745 8.86503C3.09177 8.86503 3.30903 8.86503 3.56975 8.86503H3.61321C3.74357 8.86503 3.78702 8.86503 3.83047 8.90848C3.87393 8.95193 3.91738 9.03884 3.91738 9.21265C3.91738 11.6026 3.91738 17.0915 3.91738 19.4814V21.0892C3.91738 21.8279 4.09119 22.0452 4.78644 22.219L6.82874 22.697C9.87046 23.4357 12.9122 24.1744 15.9539 24.9131C16.1277 24.9565 16.3015 25 16.4753 25C16.6492 25 16.823 25 16.9968 24.9131C19.5171 24.3048 22.0374 23.6964 24.5576 23.0881L28.0773 22.219C28.8595 22.0452 29.0333 21.8279 29.0333 21.0023V19.2642C29.0333 16.9177 29.0333 11.5157 29.0333 9.1692C29.0333 9.03884 29.0333 8.95193 29.0768 8.90848C29.1202 8.86503 29.1637 8.86503 29.294 8.86503H29.3375C29.5982 8.86503 29.8589 8.86503 30.1196 8.86503C30.4238 8.86503 30.728 8.86503 31.0756 8.86503C31.3798 8.86503 31.6405 8.73467 31.8143 8.5174C32.0316 8.30013 32.0316 7.99596 31.9012 7.69179ZM27.4255 20.3505C27.4255 20.6547 27.3386 20.7416 27.0345 20.8285C23.8624 21.5672 20.7338 22.3494 17.6051 23.1315C17.5182 23.1315 17.4748 23.175 17.4313 23.175C17.3879 23.175 17.3879 23.175 17.3444 23.175C17.301 23.1315 17.301 23.0881 17.301 22.9577C17.301 21.8714 17.301 14.3401 17.301 10.8204V7.95251C17.301 7.17035 17.301 6.3882 17.3444 5.60604L18.1266 7.21381L18.2569 7.51798C18.3873 7.7787 18.5176 7.99596 18.6046 8.25668C18.7784 8.69121 19.0825 8.86503 19.604 8.86503C20.8207 8.86503 22.0374 8.86503 23.254 8.86503H27.0345C27.4255 8.86503 27.4255 8.86503 27.4255 9.25611V11.2984C27.3821 13.2538 27.3821 18.3517 27.4255 20.3505ZM5.5686 2.60777V2.69467C7.65435 2.69467 9.7401 2.69467 11.8259 2.69467H14.9545C15.0414 2.69467 15.1718 2.69467 15.1718 2.69467C15.1718 2.73813 15.1283 2.86849 15.0848 2.91194L14.4765 4.12863C14.042 5.0846 13.564 6.04057 13.1295 6.99654C13.0425 7.17035 12.9556 7.21381 12.7384 7.21381C11.9128 7.21381 11.0872 7.21381 10.2615 7.21381H5.5686C4.8299 7.21381 4.09119 7.21381 3.30903 7.21381C3.17867 7.25726 3.17867 7.21381 3.17867 7.21381C3.17867 7.21381 3.17867 7.17035 3.22213 7.03999C3.78702 5.8233 4.43882 4.47625 5.13407 2.95539C5.22097 2.73813 5.35133 2.65122 5.5686 2.65122V2.60777ZM5.95968 8.77812V8.86503C7.08946 8.86503 8.21924 8.86503 9.30557 8.86503H9.91392C11.0437 8.86503 12.1735 8.86503 13.3467 8.86503C13.8682 8.86503 14.1723 8.64776 14.3896 8.21323C14.6938 7.51798 15.0414 6.82273 15.389 6.12748L15.6932 5.51913V6.77927C15.6932 8.12632 15.6932 17.8737 15.6932 21.1761V22.8273C15.6932 23.175 15.6932 23.2184 15.6497 23.2184C15.6063 23.2184 15.4759 23.175 15.3456 23.175L13.3902 22.697C10.9568 22.0886 8.47996 21.5237 6.04658 20.9154C5.74241 20.8285 5.65551 20.7416 5.65551 20.4374C5.65551 17.9171 5.65551 12.1675 5.65551 9.29956C5.65551 9.12575 5.65551 9.03884 5.74241 8.99539C5.78586 8.95193 5.87277 8.90848 6.04658 8.90848L5.95968 8.77812Z"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );

  const showModal = () => {
    setVisible(true);
    setIsFloting(false);
  };

  const handleClear = () => {
    setProductDetail("");
    setSelectedSample(null);
  };

  const handleSave = () => {
    setVisible(false);
    setChatData([]);
  };

  function updateScroll() {
    var element = document.getElementById("chat-messages-container");
    element.scrollTop = element.scrollHeight;
  }

  const handleChange = (value) => {
    setSelectedSample(value);
    setProductDetail(value);
  };

  return (
    <div className="chatbox">
      <Modal
        visible={visible}
        closable={false}
        className="product-detail-modal"
        maskClosable={false}
        footer={[
          <Button
            key="back"
            className="standard-button tertiary-button"
            onClick={handleClear}
          >
            Clear
          </Button>,
          <Button
            key="submit"
            className="standard-button primary-orange-button"
            type="primary"
            onClick={handleSave}
          >
            Save
          </Button>,
        ]}
      >
        <Typography.Title level={3}>
          Enter Your Product Details Here
        </Typography.Title>
        <div style={{ marginBottom: "10px" }}>
          <Typography.Text>See Some Default Examples : </Typography.Text>
          <Select
            value={selectedSample}
            className="product-details-samples-dropdown standard-dropdown"
            onChange={handleChange}
            placeholder="Select Example"
          >
            {/* <Option value=""></Option> */}
            <Option
              value="Dog Name : Max &#10;Dog Type : Golden Retriever &#10;Dog Age : 2 years old"
            >
              Dog's Example
            </Option>
            <Option
              value="Guitar Type : Martin &#10;Music Style : Jazz &#10;Experience : Professional"
            >
              Guitar's Example
            </Option>
          </Select>
        </div>
        <Input.TextArea
          rows={8}
          placeholder="For Example...&#10;Dog name : Max &#10;Dog type : Golden Retriever &#10;Dog age : 2 years old"
          value={productDetail}
          onChange={(event) => {
            setProductDetail(event.target.value);
          }}
        ></Input.TextArea>
      </Modal>
      <div className="chat-messages-container" id="chat-messages-container">
        {chatData.map((message) => {
          return message[0] === "User" ? (
            <div className="user-chat-message">
              <span className="chat-message">{message[1]}</span>
              <img src={userImage} className="profile-picture" alt="" />
            </div>
          ) : (
            <div className="bot-chat-message">
              <img src={botImage} className="profile-picture" alt="" />
              <span className="chat-message">{message[1]}</span>
            </div>
          );
        })}
      </div>
      <Form form={form} onFinish={sendMessage} className="chatbox-form">
        <Form.Item name="message" className="input-container">
          <Input className="standard-input" placeholder="Enter Your Text" />
        </Form.Item>
        <Button
          className="standard-button primary-orange-button"
          type="primary"
          htmlType="submit"
        >
          Send
        </Button>
        <Button
          className="standard-button primary-dark-blue-button"
          type="primary"
          onClick={() => clearChat()}
        >
          Clear Chat
        </Button>
        <Tooltip placement="topLeft" title="Enter Your Product Details">
          <Button
            className={`standard-button primary-dark-blue-button ${
              isFloting ? "prouct-button-float" : ""
            }`}
            onClick={showModal}
          >
            <Icon component={productSvg} />
          </Button>
        </Tooltip>
      </Form>
    </div>
  );
};

export default ChatBot;
